import type { IAgentUsageInbox, IResponseGetAgentUsage } from 'entities/AICalling/api/types.ts'
import { showItemUsageModal } from 'features/ItemUsage/showItemUsageModal.tsx'

export const checkUsageAgent = ({
  data,
  action,
  getLink,
}: {
  data: IResponseGetAgentUsage
  action: 'disable' | 'delete'
  getLink: (inbox: IAgentUsageInbox) => string
}) => {
  if (data.inboxes.length) {
    const { inboxes } = data
    const inboxesNoun = `inbox${inboxes.length === 1 ? '' : 'es'}`

    const title = `AI Agent can’t be ${action === 'disable' ? 'disabled' : 'deleted'}`
    const description = `This agent is assigned to ${inboxes.length} ${inboxesNoun}. To ${action} it, remove the
            agent from all inboxes below.`
    showItemUsageModal({
      title,
      description,
      items: inboxes.map((inbox) => ({
        key: `${inbox.team_id}-${inbox.source}-${inbox.workflow_id ?? ''}`,
        link: getLink(inbox),
        icon: 'inboxes2',
        title: inbox.team_name,
      })),
    })

    return true
  } else {
    return false
  }
}
